<script lang="ts" setup>
import story from '~/content/homepage-preview-v1'

definePageMeta({ layout: 'homepage-wide' })

useHead({
  title: 'Whole-home renewable energy systems | EPC Improvements',
  meta: [
    {
      name: 'description',
      content: 'One trusted partner to plan, design, install and support your complete home energy system.',
    },
  ],
})
</script>

<template>
  <main id="top">
    <StoryblokComponent
      v-for="(block, index) in story.content.sections[0].blocks"
      :key="block._uid"
      :story="story"
      :page="story"
      :blok="block"
      :index="index"
    />
  </main>
</template>
